import axios from 'axios';
import { getAPIBaseURL, getAuthBaseURL } from '../config'

axios.defaults.headers.common['Cache-control'] = 'no-cache, no-store';
axios.defaults.headers.common['Pragma'] = 'no-cache';
axios.defaults.headers.common['Expires'] = 0;
axios.defaults.baseURL = getAPIBaseURL()
axios.defaults.maxContentLength = 99999

axios.interceptors.response
  .use((response) => {
    if (response.data.Redirect) {
      window.location.href = response.data.Redirect;
      throw new axios.Cancel('Authentification failed. Redirecting...');
    }
    return response;
  }, (error) => {
    return Promise.reject(error);
  });


  var axiosAuthInstance = axios.create({
    baseURL: getAuthBaseURL(),
    timeout: 1000,
    headers: axios.defaults.headers,
  });

  export {axiosAuthInstance};



// WEBPACK FOOTER //
// ./src/lib/axiosConfig.ts